import * as React from "react";
function SvgGreenTick(props) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width={24} height={24} rx={12} fill="#00ABBC" /><path d="M7 12.9486L10.3394 16L17 8" stroke="white" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
export default SvgGreenTick;